/* jshint esversion: 6 */

import Choices from "choices.js";
import PerfectScrollbar from "perfect-scrollbar";
import { forms } from "./Forms/Forms.js";
import { adminCharts } from "./Charts/AdminCharts.js";
import { components } from "./Components/Components";

class Core {
  constructor() {
    this._utils();
    this._run();
  }

  _run() {
    document._kweber = document._kweber || {};
    forms();
    adminCharts();
    components();

    document._kweber.toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000
    });
  }

  _utils() {
    $('[data-toggle="tooltip"]').tooltip();

    if (document.querySelectorAll("[data-choice]").length) {
      const choices = new Choices("[data-choice]", {
        noResultsText: "Brak wyników",
        noChoicesText: "Brak opcji do wyboru",
        itemSelectText: "",
        searchFields: ["label", "value"],
        placeholder: true,
        loadingText: "Ładowanie...",
        searchPlaceholderValue: "Czego szukasz?",
        callbackOnInit: () => {
          const scrolls = document.querySelectorAll(
            ".choices__list--dropdown .choices__list"
          );
          if (Array.from(scrolls).length) {
            Array.from(scrolls).forEach(el => {
              new PerfectScrollbar(el);
            });
          }
        }
      });
    }

    if (document.querySelectorAll("[data-choice-nosearch]").length) {
      const choicesNoSearch = new Choices("[data-choice-nosearch]", {
        noChoicesText: "Brak opcji do wyboru",
        placeholder: true,
        itemSelectText: "",
        loadingText: "Ładowanie...",
        searchEnabled: false,
        callbackOnInit: () => {
          const scrolls = document.querySelectorAll(
            ".choices__list--dropdown .choices__list"
          );
          if (Array.from(scrolls).length) {
            Array.from(scrolls).forEach(el => {
              new PerfectScrollbar(el);
            });
          }
        }
      });
    }

    if (document.querySelectorAll("[data-choice-nosort]").length) {
      const choicesNoSort = new Choices("[data-choice-nosort]", {
        noChoicesText: "Brak opcji do wyboru",
        placeholder: true,
        itemSelectText: "",
        loadingText: "Ładowanie...",
        searchEnabled: false,
        shouldSort: false,
        callbackOnInit: () => {
          const scrolls = document.querySelectorAll(
            ".choices__list--dropdown .choices__list"
          );
          if (Array.from(scrolls).length) {
            Array.from(scrolls).forEach(el => {
              new PerfectScrollbar(el);
            });
          }
        }
      });
    }

    autosize(document.querySelectorAll("textarea"));
    $(".matchheight").matchHeight();
    $(".selectric").selectric();
  }
}

const ready = fn => {
  if (
    document.attachEvent
      ? document.readyState === "complete"
      : document.readyState !== "loading"
  ) {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

ready(() => {
  new Core();
});



// WEBPACK FOOTER //
// ./resources/assets/js/Core.js